import {
    createContext,
} from "react";


const PlatformAuthContext =
    createContext(
        null
    );


export default PlatformAuthContext;